import { useState } from "react";
import LastMenu from "./LastMenu";

import Mainmenu from "./MainMenu";
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 

const ApplicationAssist = () =>{

    const [showMenu, setShowMenu] = useState(true);
    const [showFrame1, setShowFrame1] = useState(false);
    const [showFrame2, setShowFrame2] = useState(false);
    const [showFrame3, setShowFrame3] = useState(false);
    const [showFrame4, setShowFrame4] = useState(false);

    
      const [time, setTime] = useState(new Date());

    return (
        <>
            <div className="frame1 animated-frame">
            What do you want to know more about?
            </div>
            {showMenu &&
                <div className="menu-btns animated-frame">
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(true);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                    }}
                >Application Fee</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(true);
                        setShowFrame3(false);
                        setShowFrame4(false);
                    }}
                >Application Status</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(true);
                        setShowFrame4(false);
                    }}
                >Letter of Reference Status</button>
                
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(true);
                    }}
                >Restart the chat</button>
            </div>}

            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Application Fee
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    There is no fee for applying to an HBS Executive Education program.
                    </div>
                    <LastMenu id={4} />
                </>
            )}

            {showFrame2 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Application Status
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Response time to applications varies by program. You can track your application status through the My Account application portal or contact our Admissions department atexed_admissions@hbs.edu.
                    </div>
                    <LastMenu id={4} />
                </>
            )}

            {showFrame3 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Letter of Reference Status
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    You can track whether your letter of reference or nominating statement has been submitted through the My Account application portal. All application materials must be submitted before your application is considered.
                    </div>
                    <LastMenu id={4} />
                </>
            )}


            {showFrame4 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
            )}



        </>
    );
}

export default ApplicationAssist;